export default {
  data() {
    return {
      unicoCameraBuilder: null,
      unicoConfig: null,
      selfieCameraTypes: null
    };
  },
  computed: {
    publicPath() {
      return process.env.BASE_URL;
    },
    hostname() {
      return process.env.VUE_APP_UNICO_HOSTNAME ?? "";
    },
    hostKey() {
      return process.env.VUE_APP_UNICO_HOST_KEY ?? "";
    },
    isProd() {
      return process.env.NODE_ENV === "production";
    }
  },
  async created() {
    if (!this.hostname) {
      if (window) window.$log.error("Sem parametrização para biometria");
      return;
    }

    const sdkUrl = `${window.location.origin}${this.publicPath}scripts/unico-webframe.esm.js`;
    const { UnicoConfig, UnicoCheckBuilder, SelfieCameraTypes, UnicoThemeBuilder, LocaleTypes, SDKEnvironmentTypes } =
      await import(/* webpackIgnore: true */ sdkUrl);

    this.unicoConfig = new UnicoConfig().setHostname(this.hostname).setHostKey(this.hostKey);

    this.unicoCameraBuilder = new UnicoCheckBuilder();
    this.unicoCameraBuilder.setResourceDirectory(`${this.publicPath}resources`);
    this.unicoCameraBuilder.setModelsPath(`${window.location.origin}${this.publicPath}models`);
    this.unicoCameraBuilder.setLocale(LocaleTypes.PT_BR);
    this.unicoCameraBuilder.setEnvironment(this.isProd ? SDKEnvironmentTypes.PROD : SDKEnvironmentTypes.UAT);

    const unicoTheme = new UnicoThemeBuilder()
      .setColorSilhouetteSuccess("#00C37D")
      .setColorSilhouetteError("#C31700")
      .setColorSilhouetteNeutral("#fff")
      .setBackgroundColor("#fff")
      .setColorText("#4E4E4E")
      .setBackgroundColorComponents("#172972")
      .setColorTextComponents("#FFF")
      .setBackgroundColorButtons("#172972")
      .setColorTextButtons("#FFF")
      .setBackgroundColorBoxMessage("#fff")
      .setColorTextBoxMessage("#4E4E4E")
      .setColorCancelButton("#172972")
      .setColorProgressBar("#172972")
      .setFontFamily("inherit")
      .setHtmlPopupLoading(
        `<div style="position: absolute; top: 50%; right: 50%; transform: translate(50%, -50%); z-index: 10; text-align: center;">Carregando...</div>`
      )
      .build();

    this.unicoCameraBuilder.setTheme(unicoTheme);
    this.selfieCameraTypes = SelfieCameraTypes;
    this.initCameraUnico();
  }
};
